(() => {
  if (window.sxReviewsInitialized) return;
  window.sxReviewsInitialized = true;
  let loader;
  let activeDialog;
  const parsePosts = (source) => {
    try {
      const values = JSON.parse(source);
      if (!Array.isArray(values)) return [];
      const seen = new Set();
      return values.slice(0, 50).flatMap((value) => {
        if (!value || typeof value.url !== 'string') return [];
        let url;
        try { url = new URL(value.url); } catch { return []; }
        const match = url.pathname.match(/^\/(?:[A-Za-z0-9_]+|i\/web)\/status\/(\d+)(?:\/.*)?$/);
        if (url.protocol !== 'https:' || !['x.com', 'www.x.com', 'twitter.com', 'www.twitter.com'].includes(url.hostname) || !match || seen.has(match[1])) return [];
        seen.add(match[1]);
        return [{ id: match[1], url: `https://x.com/i/status/${match[1]}`, pr: value.pr === true }];
      });
    } catch { return []; }
  };
  const widgets = () => {
    if (window.twttr?.widgets?.createTweet) return Promise.resolve(window.twttr);
    if (loader) return loader;
    loader = new Promise((resolve, reject) => {
      let timer;
      const timeout = setTimeout(() => { clearInterval(timer); reject(new Error('X widgets unavailable')); }, 12000);
      timer = setInterval(() => {
        if (window.twttr?.widgets?.createTweet) {
          clearTimeout(timeout); clearInterval(timer); resolve(window.twttr);
        }
      }, 100);
      if (!document.querySelector('script[src="https://platform.twitter.com/widgets.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://platform.twitter.com/widgets.js'; script.async = true;
        document.head.append(script);
      }
    }).catch(error => { loader = undefined; throw error; });
    return loader;
  };
  const timeout = (promise, delay) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('X post unavailable')), delay);
    promise.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
  const isDemo = rating => rating.dataset.demo === 'true' && window.Shopify?.theme?.id === 193242038564 && window.Shopify?.theme?.role === 'unpublished';
  const open = (rating, trigger) => {
    const demo = isDemo(rating);
    const previewPosts = [
      { url: 'https://x.com/Bw6E1/status/2088426423463928077', pr: true },
      { url: 'https://x.com/0419kanarii/status/2089542421269078318', pr: true }
    ];
    const selectedPreview = rating.dataset.productId === '10286444183844' ? [previewPosts[0]] : rating.dataset.productId === '10311237370148' ? [previewPosts[1]] : previewPosts;
    const posts = parsePosts(demo ? JSON.stringify(selectedPreview) : rating.dataset.posts);
    if (!posts.length) return;
    if (activeDialog) activeDialog.close();
    const dialog = rating.querySelector('template').content.querySelector('dialog').cloneNode(true);
    const hub = rating.closest('sx-review-hub');
    if (hub) {
      const picker = document.createElement('label'); picker.className = 'sx-hub-dialog-picker';
      picker.textContent = hub.querySelector('label').textContent;
      const select = hub.querySelector('select').cloneNode(true); select.removeAttribute('id'); select.className = 'sx-hub-dialog-select'; select.value = rating.dataset.productId;
      picker.append(select); dialog.querySelector('.sx-review-dialog__header').append(picker);
      select.addEventListener('change', () => {
        hub.querySelector('select').value = select.value; hub.show();
        const nextRating = hub.querySelector('.sx-hub__panel:not([hidden]) sx-review-rating');
        if (nextRating) { dialog.close(); open(nextRating, hub.querySelector('.sx-hub__more')); }
      });
      trigger = hub.querySelector('.sx-hub__more');
    }
    const grid = dialog.querySelector('.sx-review-posts');
    const more = dialog.querySelector('.sx-review-more');
    const status = dialog.querySelector('.sx-review-status');
    const previousOverflow = activeDialog?._sxPreviousOverflow ?? document.documentElement.style.overflow;
    dialog._sxPreviousOverflow = previousOverflow;
    let displayed = 0;
    const appendPosts = () => {
      const previousCount = displayed;
      const next = posts.slice(displayed, displayed + 3);
      next.forEach(post => {
        const card = document.createElement('article'); card.className = 'sx-review-post';
        const heading = document.createElement('div'); heading.className = 'sx-review-post__heading'; heading.textContent = grid.dataset.postLabel;

        const embed = document.createElement('div'); embed.className = 'sx-review-embed';
        const fallback = document.createElement('p'); fallback.className = 'sx-review-fallback'; fallback.textContent = grid.dataset.fallbackLabel;
        const link = document.createElement('a'); link.className = 'sx-review-source'; link.href = post.url; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.textContent = grid.dataset.openLabel;
        card.append(heading, embed, fallback, link); grid.append(card);
        widgets().then(twitter => {
          if (!dialog.open) return null;
          return timeout(twitter.widgets.createTweet(post.id, embed, { theme: 'light', dnt: true, lang: document.documentElement.lang.startsWith('ja') ? 'ja' : 'en', conversation: 'none', align: 'center' }), 15000);
        }).then(element => { if (element) fallback.hidden = true; }).catch(() => { fallback.hidden = false; });
      });
      displayed += next.length;
      status.textContent = status.dataset.countLabel.replace('[shown]', displayed).replace('[total]', posts.length);
      more.hidden = displayed >= posts.length;
      if (more.hidden && document.activeElement === more) {
        const firstNewCard = grid.children[previousCount];
        if (firstNewCard) { firstNewCard.tabIndex = -1; firstNewCard.focus({ preventScroll: true }); }
      }
    };
    dialog.querySelector('.sx-review-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (activeDialog === dialog) {
        document.documentElement.style.overflow = previousOverflow;
        activeDialog = undefined;
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      }
      dialog.remove();
    }, { once: true });
    more.addEventListener('click', appendPosts);
    document.body.append(dialog); dialog.showModal(); activeDialog = dialog;
    document.documentElement.style.overflow = 'hidden'; appendPosts();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.sx-review-trigger');
    if (!trigger) return;
    const rating = trigger.closest('sx-review-rating');
    if (!rating) return;
    event.preventDefault(); event.stopPropagation(); open(rating, trigger);
  });
  if (!customElements.get('sx-review-rating')) customElements.define('sx-review-rating', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.demo === 'true') {
        if (isDemo(this)) { this.hidden = false; this.style.removeProperty('display'); }
        else { this.hidden = true; this.style.display = 'none'; }
      } else if (!parsePosts(this.dataset.posts).length) this.style.display = 'none';
    }
  });
  document.addEventListener('shopify:section:unload', () => { if (activeDialog) activeDialog.close(); });
})();
